import moment from "moment";

export const computeOnTime = (orderDueDate, isOrderComplete) => {
  return (moment(orderDueDate).isBefore(moment()) && isOrderComplete == 1) ||
    moment(orderDueDate).isAfter(moment());
};
